/// <reference types="highlight.js" />
/// <reference types="react-syntax-highlighter" />

import hljs from 'highlight.js/lib/core';
import bash from 'react-syntax-highlighter/dist/cjs/languages/hljs/bash';
import css from 'react-syntax-highlighter/dist/cjs/languages/hljs/css';
import dart from 'react-syntax-highlighter/dist/cjs/languages/hljs/dart';
import diff from 'react-syntax-highlighter/dist/cjs/languages/hljs/diff';
import go from 'react-syntax-highlighter/dist/cjs/languages/hljs/go';
import ini from 'react-syntax-highlighter/dist/cjs/languages/hljs/ini';
import java from 'react-syntax-highlighter/dist/cjs/languages/hljs/java';
import javascript from 'react-syntax-highlighter/dist/cjs/languages/hljs/javascript';
import json from 'react-syntax-highlighter/dist/cjs/languages/hljs/json';
import kotlin from 'react-syntax-highlighter/dist/cjs/languages/hljs/kotlin';
import markdown from 'react-syntax-highlighter/dist/cjs/languages/hljs/markdown';
import python from 'react-syntax-highlighter/dist/cjs/languages/hljs/python';
import ruby from 'react-syntax-highlighter/dist/cjs/languages/hljs/ruby';
import rust from 'react-syntax-highlighter/dist/cjs/languages/hljs/rust';
import scss from 'react-syntax-highlighter/dist/cjs/languages/hljs/scss';
import sql from 'react-syntax-highlighter/dist/cjs/languages/hljs/sql';
import swift from 'react-syntax-highlighter/dist/cjs/languages/hljs/swift';
import typescript from 'react-syntax-highlighter/dist/cjs/languages/hljs/typescript';
import xml from 'react-syntax-highlighter/dist/cjs/languages/hljs/xml';
import yaml from 'react-syntax-highlighter/dist/cjs/languages/hljs/yaml';
import SyntaxHighlighter from 'react-syntax-highlighter/dist/cjs/light';

const languages = {
  bash,
  css,
  dart,
  diff,
  go,
  ini,
  java,
  javascript,
  json,
  kotlin,
  markdown,
  python,
  ruby,
  rust,
  scss,
  sql,
  swift,
  typescript,
  xml,
  yaml,
};

type Language = keyof typeof languages;

const aliases: Record<string, Language> = {
  cjs: 'javascript',
  golang: 'go',
  html: 'xml',
  js: 'javascript',
  jsx: 'javascript',
  kt: 'kotlin',
  kts: 'kotlin',
  md: 'markdown',
  mdx: 'markdown',
  mjs: 'javascript',
  patch: 'diff',
  py: 'python',
  rb: 'ruby',
  rs: 'rust',
  sh: 'bash',
  shell: 'bash',
  toml: 'ini',
  ts: 'typescript',
  tsx: 'typescript',
  yml: 'yaml',
  zsh: 'bash',
};

for (const [name, definition] of Object.entries(languages)) {
  SyntaxHighlighter.registerLanguage(name, definition);
}

const resolveLanguage = (language: string): string => {
  const normalized = language.toLowerCase();
  const canonical = aliases[normalized] ?? normalized;
  return hljs.getLanguage(canonical) ? canonical : 'text';
};

export { resolveLanguage, SyntaxHighlighter };
